import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { getAuthState } from "@redriver/cinnamon";
import { MagicLinkSignIn } from "features/System";
import { AppRoutes } from "constants/routes";
import { PublicPageContent } from "components/pages";

const MagicLinkSignInPage = ({ loggedIn, match }) => {
  if (loggedIn) {
    return <Redirect to={AppRoutes.Root} />;
  }

  return (
    <PublicPageContent>
      <MagicLinkSignIn token={match.params.token || ""} />
    </PublicPageContent>
  );
};

const mapStateToProps = (state) => ({
  loggedIn: getAuthState(state).loggedIn,
});

export default connect(mapStateToProps)(MagicLinkSignInPage);
